import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Title Cases a display name: trims, lower-cases, then capitalizes the first
 * letter of each token (split on whitespace and common separators). Apostrophes
 * are left untouched so "tony's" -> "Tony's" rather than "Tony'S". Acronyms are
 * not preserved ("BBQ" -> "Bbq"). Mirrors the server-side helper in
 * diagnostics-analytics so item/category names render consistently.
 */
export function toTitleCase(value: string | null | undefined): string {
  if (!value) return "";
  return value
    .trim()
    .toLowerCase()
    .replace(/(^|[\s/(\-&])([a-z])/g, (_m, sep: string, ch: string) => sep + ch.toUpperCase());
}
